'use client';

import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';

const AddressNavigation = () => {
  return null;
};

export default AddressNavigation;
